_collow.components.Overlay = class Overlay extends _collow.components.Base {
  root;
  elements;
  params;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    //TODO take a look if this is matching specific and can be removed
    this.listen(document.body, "change", ({ target }) => {
      switch (target.id) {
        case "decline-contact":
        case "accept-contact":
        case "company-user-info":
          this.root[target.checked ? "removeAttribute" : "setAttribute"](
            "hidden",
            ""
          );
      }
    });

    this.listen(document.body, "_collow.enlarge-image", this.showImage);
    this.listen(
      document,
      [
        "_collow.popup",
        "_collow.open-popup",
        "_collow.close-popup",
        "_collow.popup.message",
        "_collow.open.message",
      ],
      this.showOverlay
    );
  }

  showOverlay = ({ detail }) => {
    this.root[detail.type == "open" ? "removeAttribute" : "setAttribute"](
      "hidden",
      ""
    );
    this[detail.type == "open" ? "listen" : "unlisten"](
      this.root,
      "click",
      () => this.dispatch(this.root, "_collow.overlay.clicked")
    );
  };

  // TODO clean this up with a diffrent component
  showImage = (event) => {
    const { src } = event.detail;
    this.root.removeAttribute("hidden");
    this.root.style.backgroundImage = `url("${src}")`;

    setTimeout(() => {
      ["_collow.escape.keydown", "_collow.hide-image", "click"].forEach(
        (event) => this.listen(document.body, event, this.hideImage)
      );
    }, 200);
  };

  hideImage = () => {
    ["_collow.escape.keydown", "_collow.hide-image", "click"].forEach((event) =>
      this.unlisten(document.body, event, this.hideImage)
    );
    this.root.setAttribute("fading", "");
    setTimeout(() => {
      this.root.style.backgroundImage = "";
      this.root.setAttribute("hidden", "");
      this.root.removeAttribute("fading");
    }, 400);
  };
};
